import React, { useEffect, useState } from "react";
import ApplicationContainer from "../../../state/containers/ApplicationContainer";
import { css } from '@emotion/css';
import TabContainerPanel from '../../../components/structure/Panels/TabContainerPanel';
import { TabPanel } from "react-tabs";
import SimulatorUserProfile from "./SimulatorUserProfile";
import LanguageModel from "../../../models/features/api/LanguageModel";
import SimulatorPinnedMessagesPanel from "./SimulatorPinnedMessagesPanel";
import UserApplicationPreferencesContainer from "../../../state/containers/UserApplicationPreferencesContainer";
import { SimulatorMessage } from "./SimulatorInteraction";
import SimulatorTestCasesPanel from "./SimulatorTestCasesPanel";
import TestCase from '../../../models/customAssistant/TestCase';
import TestCaseContainer from "../../../hooks/TestCaseContainer";
import WebhookModel from "../../../models/webhooks/api/WebhookModel";
const userIcon = require('../../../content/images/simulator/user.svg');
const userSelectedIcon = require('../../../content/images/user-selected.svg');
const thumbtackIcon = require('../../../content/images/simulator/thumbtack.svg');
const thumbtackSelectedIcon = require('../../../content/images/simulator/thumbtack-selected.svg');
const wrenchIcon = require('../../../content/images/wrench-dark.svg');
const wrenchSelected = require('../../../content/images/wrench-blue.svg');

interface SimulatorInputProps {
    applicationId: string,
    appContainer: ApplicationContainer,
    userApplicationPreferencesContainer: UserApplicationPreferencesContainer,
    languages: LanguageModel[],
    selectedLanguage: LanguageModel, 
    requests?: SimulatorMessage[],
    handleSendMessage: (text: string) => void
    handleSendWelcome: () => void
    handleLanguageSelected: (language: LanguageModel) => void
    handleStartNewSession: () => void
    simulateTestCase: (testCase: TestCase) => void
    webhooks?: WebhookModel[]
    onOpenWebhookOverrides?: () => void
}

const SimulatorInputPanel: React.FC<SimulatorInputProps> = (props) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const testCaseContainer = TestCaseContainer.useContainer();
    const updateSelectedIndex = (index: number) => {
        setSelectedIndex(index);
    };
    useEffect(() => {
        testCaseContainer.setApplication(props.appContainer?.state.currentApp);
    }, [props.appContainer?.state.currentApp?.id]);

    return (
        <TabContainerPanel
            selectedIndex={selectedIndex}
            onTabSelected={(index) => { updateSelectedIndex(index) }}
            className={containerStyle}
            tabs={[
                {
                    title: "Tests",
                    icon: thumbtackIcon,
                    selectedIcon: thumbtackSelectedIcon,
                    className: "ac-simulator-pinned-tab"
                },
                {
                    title: "Tools",
                    icon: wrenchIcon,
                    selectedIcon: wrenchSelected,
                    className: "ac-simulator-pinned-tab"
                },
                {
                    title: "Language",
                    icon: userIcon,
                    selectedIcon: userSelectedIcon,
                    className: "ac-simulator-user-tab"
                }
            ]}>
            <TabPanel>
                <SimulatorTestCasesPanel
                    handleSendWelcome={props.handleSendWelcome}
                    applicationId={props.applicationId}
                    userApplicationPreferencesContainer={props.userApplicationPreferencesContainer}
                    languages={props.languages}
                    selectedLanguage={props.selectedLanguage}
                    handleStartNewSession={props.handleStartNewSession}
                    requests={props.requests}
                    simulateTestCase={(tc) => props.simulateTestCase(tc)}
                />
            </TabPanel>
            <TabPanel>
                <SimulatorPinnedMessagesPanel
                    handleSendWelcome={props.handleSendWelcome}
                    applicationId={props.applicationId}
                    userApplicationPreferencesContainer={props.userApplicationPreferencesContainer}
                    languages={props.languages}
                    selectedLanguage={props.selectedLanguage}
                    handleSendMessage={(text: string) => props.handleSendMessage(text)}
                    handleStartNewSession={props.handleStartNewSession}
                    requests={props.requests}
                    onOpenWebhookOverrides={props.onOpenWebhookOverrides}
                />
            </TabPanel>
            <TabPanel>
                <SimulatorUserProfile
                    appContainer={props.appContainer}
                    applicationId={props.applicationId}
                    languages={props.languages}
                    selectedLanguage={props.selectedLanguage}
                    handleLanguageSelected={(language) => { props.handleLanguageSelected(language) }}
                    handleStartNewSession={props.handleStartNewSession}
                />
            </TabPanel>
        </TabContainerPanel>
    )
}

const containerStyle = css`
    width: 432px;
    max-width: 432px;
    flex: 1;
`;

export default SimulatorInputPanel;